import { Link } from 'react-router-dom';
import './NoMatchV2.css';
import NavbarV2 from '../../components/navbarV2/NavbarV2';

const NoMatchV2 = () => {
    return (
        <div className="v2-page nomatchv2">
            <NavbarV2 />

            <div className="nomatchv2-inner">
                <div className="nomatchv2-panel">
                    <p className="nomatchv2-code">404</p>
                    <h1 className="nomatchv2-title">Page not found</h1>
                    <p className="v2-muted nomatchv2-text">
                        The page you requested doesn&apos;t exist or has moved. Head back home to continue shopping.
                    </p>
                    <Link to="/" className="v2-btn v2-btn--primary nomatchv2-cta">
                        Back to home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default NoMatchV2;
